module.exports = __webpack_public_path__ + "static/structured-plans-f1284b65b96e90414c1ab58831b2d534.svg";